<template>
	<BasicLayout>
		<el-card class="filter-card">
			<el-row :gutter="20">
				<el-col 
					:xs="24" 
					:sm="9" 
					v-bind:md="showCriteriaOnlyWithoutDestCRA ? 7 : 6" 
					:lg="5" 
					:xl="5" 
					class="col1">
					<el-date-picker size="small"
						start-placeholder="Date de début"
						end-placeholder="Date de fin"
						range-separator="au"
						prefix-icon="far fa-calendar-alt"
    					v-model="criteria.dateRange"
						v-on:input="setRange"
						type="daterange"
						format="dd MMM yyyy"
						:clearable="false"
						value-format="yyyy-MM-dd">
					</el-date-picker>
				</el-col>
				<el-col 
					:xs="24" 
					:sm="15" 
					v-bind:md="showCriteriaOnlyWithoutDestCRA ? 17 : 6" 
					v-bind:lg="showCriteriaOnlyWithoutDestCRA ? 4 : 8" 
					v-bind:xl="showCriteriaOnlyWithoutDestCRA ? 4 : 8" 
					class="col2">
					<el-input size="small"
						placeholder="Rechercher"
						prefix-icon="fas fa-search"
						v-on:input="setSearchQueries"
						v-on:clear="setSearchQueries"
						v-model="criteria.searchQuery"
						clearable>
					</el-input>
				</el-col>
				<el-col
					:xs="24" 
					v-bind:sm="showCriteriaOnlyWithoutDestCRA ? 6 : 9" 
					v-bind:md="showCriteriaOnlyWithoutDestCRA ? 7 : 4" 
					:lg="4" 
					:xl="3" 
					class="col3">
					<el-checkbox size="small" v-model="criteria.showClosed" v-on:input="setCriteria" label="Voir les bilans clos" border v-if="!isDae"></el-checkbox>
					<el-checkbox size="small" v-model="criteria.showClosedDae" v-on:input="setCriteria" label="Voir les DAE clos" border v-if="isDae"></el-checkbox>
				</el-col>
				<el-col 
					v-if="showCriteriaOnlyWithoutDestCRA"
					:xs="24" 
					:sm="6" 
					:md="8" 
					:lg="4" 
					:xl="4" 
					class="col3">
					<el-checkbox size="small" v-model="criteria.onlyWithoutDestCRA" v-on:input="setCriteria" label="Sans devenir CRRA" border></el-checkbox>
				</el-col>
				<el-col 
					:xs="24" 
					v-bind:sm="showCriteriaOnlyWithoutDestCRA ? 9 : 15" 
					:md="8" 
					:lg="7" 
					:xl="8" 
					class="col4">
					<el-badge :value="counters.RED" class="color-button-badge red" type="primary" :hidden="counters.RED === 0" title="Nombre de bilan rouge restant à traiter">
						<el-button size="small" v-on:click="toggleColor(colors.ROUGE)" class="rouge-color rouge-background lightColor hover" title="Rouge">
							<i class="fas fa-check" v-bind:class="{ hidden: criteria.displayedColors.indexOf(colors.ROUGE) === -1 }"></i>
						</el-button>
					</el-badge>
					<el-badge :value="counters.YELLOW" class="color-button-badge yellow" type="primary" :hidden="counters.YELLOW === 0" title="Nombre de bilan jaune restant à traiter">
						<el-button size="small" v-on:click="toggleColor(colors.JAUNE)" class="jaune-color jaune-background lightColor hover" title="Jaune">
							<i class="fas fa-check" v-bind:class="{ hidden: criteria.displayedColors.indexOf(colors.JAUNE) === -1 }"></i>
						</el-button>
					</el-badge>
					<el-badge :value="counters.GREEN" class="color-button-badge green" type="primary" :hidden="counters.GREEN === 0" title="Nombre de bilan vert restant à traiter">
						<el-button size="small" v-on:click="toggleColor(colors.VERT)" class="vert-color vert-background lightColor hover" title="Vert">
							<i class="fas fa-check" v-bind:class="{ hidden: criteria.displayedColors.indexOf(colors.VERT) === -1 }"></i>
						</el-button>
					</el-badge>
					<el-badge :value="counters.WHITE" class="color-button-badge white" type="primary" :hidden="counters.WHITE === 0" title="Nombre de bilan blanc restant à traiter">
						<el-button size="small" v-on:click="toggleColor(colors.BLANC)" class="blanc-color blanc-background lightColor hover" title="Blanc">
							<i class="fas fa-check" v-bind:class="{ hidden: criteria.displayedColors.indexOf(colors.BLANC) === -1 }"></i>
						</el-button>
					</el-badge>

					<el-button-group style="position: absolute; right: 10px;">
						<el-button v-if="showClearButton" size="small" icon="fas fa-fw fa-times" circle plain v-on:click="clearCriteria()" title="Effacer tous les critères de recherche"></el-button>
						<el-button :loading="processing" size="small" icon="fas fa-fw fa-sync-alt" v-on:click="getData(true)" circle plain title="Actualiser la liste"></el-button>
					</el-button-group>
				</el-col>
			</el-row>
		</el-card>

		<el-card class="victims-card" :class="{ small: showCriteriaOnlyWithoutDestCRA }">

			<el-progress :percentage="percent" :show-text="false" :stroke-width="1"></el-progress>
			
			<el-table ref="victimsTable"
				v-loading="loading"
				:data="filteredVictims" 
				:row-class-name="rowClassName" 
				:header-row-class-name="'victim-header'"
				:default-sort="{prop: 'checkupReceiptDate', order: 'descending'}"
				@row-click="clickRow"
				style="width: 100%"
				border 
				height="calc(100vh - 290px)"
				class="victims-table"
				v-bind:class="{ sau: isSau || isTmp }"
				empty-text="Aucun bilan ne correspond à ces critères">

				<!-- ENGIN -->
				<el-table-column label="Engin" align="center">
					<el-table-column label="Engin" width="94" align="center" sortable sort-by="vehicleName">
						<template slot-scope="scope">
							<vehicle-tag v-bind:vehicle="scope.row.vehicleName" 
								v-bind:fireunit="scope.row.fireunitShortname" 
								v-bind:color="scope.row.checkupColor" />
						</template>
					</el-table-column>
					
					<el-table-column label="Statut" prop="vehicleState.code" width="74" align="center" sortable>
						<template slot-scope="scope">
							<el-tooltip v-bind:content="scope.row.vehicleState.name" placement="top" v-if="scope.row.vehicleState">
								<div>{{scope.row.vehicleState.code}}</div>
							</el-tooltip>
						</template>
					</el-table-column>
				</el-table-column>
				
				<!-- BILAN -->
				<el-table-column label="Bilan" align="center">
					<el-table-column label="French" width="75" align="center" sortable :sort-method="sortByFrench">
						<template slot-scope="scope">
							<span>{{scope.row.french}}</span>
						</template>
					</el-table-column>

					<el-table-column label="Etat" prop="checkupState.code" width="64" align="center" sortable>
						<template slot-scope="scope">
							<el-tooltip v-bind:content="scope.row.checkupState.name" placement="top">
								<div>{{scope.row.checkupState.code}}</div>
							</el-tooltip>
						</template>
					</el-table-column>
					
					<el-table-column  prop="checkupReceiptDate" label="Heure" width="74" align="center" sortable :sort-method="sortByDate">
						<template slot-scope="scope">
							{{getFormatedHour(scope.row.checkupReceiptDate)}}<br>
							{{getFormatedDate(scope.row.checkupReceiptDate)}}
						</template>
					</el-table-column>

					<el-table-column label="PJ" width="36" align="center" v-if="!isDae">
						<template slot-scope="scope">
							<i v-if="scope.row.checkupFileCount" class="fas fa-lg fa-paperclip"></i>
						</template>
					</el-table-column>

				</el-table-column>


				<!-- DAE -->
				<el-table-column label="DAE" align="center" v-if="isDae">
					<el-table-column label="Etat" width="64" align="center" >
						<template slot-scope="scope">
							{{scope.row.daeCode}}
						</template>
					</el-table-column>
				</el-table-column>
				
				<!-- VICTIME -->
				<el-table-column label="Victime" align="center">
					<el-table-column label="Age" width="65" align="center" sortable :sort-method="sortByAge">
						<template slot-scope="scope">
							<div v-if="scope.row.age"><age v-bind:value="scope.row.age" v-bind:type="scope.row.ageType" /></div>
							{{scope.row.gender}} <span v-if="scope.row.weight">{{scope.row.weight}} kg</span>
						</template>
					</el-table-column>
					
					<el-table-column label="Nom" width="92" sortable :sort-method="sortByName">
						<template slot-scope="scope">
							{{scope.row.lastname}}<br>
							{{scope.row.firstname}}
						</template>
					</el-table-column>
				</el-table-column>

				<!-- INTERVENTION -->
				<el-table-column label="Intervention" align="center">
					<el-table-column label="Adresse" sortable :sort-method="sortByAddress" min-width="150">
						<template slot-scope="scope">
							<div v-if="scope.row.address1">{{scope.row.address1}}</div>
							<div v-if="scope.row.address2">{{scope.row.address2}}</div>
							<div v-if="scope.row.address3">{{scope.row.address3}}</div>
							<div><span v-if="scope.row.zipCode">{{scope.row.zipCode}} </span> <span v-if="scope.row.town">{{scope.row.town}} </span></div>
						</template>
					</el-table-column>
				</el-table-column>
				
				<!-- SDIS -->
				<el-table-column label="SDIS" align="center">
					<el-table-column label="Nature" prop="disasterName" :width="isSau || isTmp ? 180 : 140" :show-overflow-tooltip="true" sortable :sort-method="sortByDisaster"></el-table-column>
					
					<el-table-column label="Devenir" prop="destinationSP" width="120" sortable :sort-method="sortByDestinationSP" v-if="!isSau && !isTmp">
						<template slot-scope="scope">
							<el-tooltip :content="tooltipTextDevenirSP(scope.row)" :disabled="!!!tooltipTextDevenirSP(scope.row)" placement="top">
								<div v-if="!!scope.row.destinationSP">{{scope.row.destinationSP}}</div>
								<div v-if="!scope.row.destinationSP && !scope.row.transportSP" style="text-align center;">
									<i class="fas fa-ban" style="color: tomato"></i>&nbsp;Pas de transport
								</div>
							</el-tooltip>
						</template>
					</el-table-column>
				</el-table-column>
				
				<!-- CRRA -->
				<el-table-column label="CRRA" align="center" v-if="!isDae">
					<el-table-column label="Observation" column-key="obs" class-name="obs-cell" :show-overflow-tooltip="true" sortable :sort-method="sortByObservationCRA" min-width="200">
						<template slot-scope="scope">
							<div v-if="!scope.row.editObs"><i class="fas fa-fw fa-edit" v-if="isCra || isSystem"></i>&nbsp;{{scope.row.observationCRA}}</div>
							<div v-if="scope.row.editObs" class="cell-edit">
								<el-input 
									:ref="'obsInput' + scope.row.id"
									placeholder="Observation" 
									v-model="scope.row.observationCRA_edit"
									type="textarea"
									:autosize="{minRows: 1, maxRows: 4}"
									maxlength="500"
									show-word-limit
									class="obs-input">
								</el-input>
								<div class="cell-edit-btn">
									<i class="fas fa-fw fa-lg fa-save vert-color hover" title="Enregistrer" v-on:click.stop="saveObs(scope.row)"></i>
									<i class="fas fa-fw fa-lg fa-times rouge-color hover" title="Annuler" v-on:click.stop="scope.row.editObs = false"></i>
								</div>
							</div>
						</template>
					</el-table-column>
					
					<el-table-column label="Devenir" column-key="dest-cra" class-name="dest-cell" width="200" sortable :sort-method="sortByDestinationCRA" v-if="!isSau && !isTmp" >
						<template slot-scope="scope">
							<div v-if="!scope.row.editDest && (!!scope.row.destinationCRA || scope.row.transportCRA)"><i class="fas fa-fw fa-edit" v-if="isCra || isSystem"></i>&nbsp;{{scope.row.destinationCRA}}</div>
							<div v-if="!scope.row.editDest && !scope.row.destinationCRA && !scope.row.transportCRA"><i class="fas fa-fw fa-edit" v-if="isCra || isSystem"></i>&nbsp;<i class="fas fa-ban" style="color: tomato"></i>&nbsp;Pas de transport</div>
							<div v-if="scope.row.editDest" class="cell-edit">
								<el-select :ref="'destSelect' + scope.row.id" v-model="scope.row.destId" filterable placeholder="Destination" size="small">
									<el-option-group label="Autre">
										<el-option :value="'NO_TRANSP'" :label="'Pas de transport'">
											<div><i class="fas fa-ban" style="color: tomato"></i>&nbsp;Pas de transport</div>
										</el-option>
									</el-option-group>
									<el-option-group label="SAU référencés">
										<el-option
											v-for="entity in entitiesSAU"
											:key="entity.id"
											:label="entity.name"
											:value="entity.id"
											class="entity-option">
											<div>{{ entity.name }}</div>
											<div class="subtext">{{ entity.address }}</div>
										</el-option>
									</el-option-group>
									<el-option-group label="Destination éphémères">
										<el-option
											v-for="tmpUser in tmpUsers"
											:key="tmpUser.id"
											:value="tmpUser.id"
											:label="tmpUser.lastname + (tmpUser.firstname ? ' ' + tmpUser.firstname : '')"
											class="entity-option">
											<div>{{ tmpUser.lastname }} {{ tmpUser.firstname }}</div>
											<div class="subtext">{{ tmpUser.email }}</div>
										</el-option>
									</el-option-group>
								</el-select>
								<div class="cell-edit-btn">
									<i class="fas fa-fw fa-lg fa-save vert-color hover" title="Enregistrer" v-on:click.stop="saveDest(scope.row)"></i>
									<i class="fas fa-fw fa-lg fa-times rouge-color hover" title="Annuler" v-on:click.stop="scope.row.editDest = false"></i>
								</div>
							</div>
						</template>
					</el-table-column>

					<el-table-column label="Prescriptions" column-key="pres-cra" class-name="pres-cell" width="112" sortable :sort-method="sortByPrescriptionCount">
						<template slot-scope="scope">
							<i class="fas fa-fw fa-edit" v-if="isDoctor"></i>&nbsp;{{scope.row.prescriptionCount}}
						</template>
					</el-table-column>
				</el-table-column>
				
				
			</el-table>
		</el-card>
	</BasicLayout>
</template>

<script>
import BasicLayout from '@/layouts/basic.layout.vue'
import VictimService from '@/services/victim.service'
import EntityService from '@/services/entity.service'
import UserService from '@/services/user.service'
import StringUtils from '@/utils/string.utils'
import VehicleTag from '@/components/vehicle.tag.component.vue'
import Age from '@/components/age.component.vue'
import Colors from '@/constants/colors.const.js'
import EntityTypes from '@/constants/entity.types.const.js'
import moment from 'moment';

export default {
	name: 'checkups',
	components: {
		BasicLayout,
		VehicleTag,
		Age
	},
	data: function () {
		return {
			delai: 30000,
			currentTime: 0, 
			intervalId: 0,
			suspendRefresh: false,
			victims: [],
			loading: true,
			processing: false,
			colors: Colors,
			entitiesSAU: [],
			tmpUsers: [],
			showClearButton: false,
			criteria: {
				dateRange: [],
				defaultDateRange: true,
				searchQuery: '',
				searchQueries: [],
				showClosed: false,
				showClosedDae : false,
				onlyWithoutDestCRA: false,
				displayedColors: [Colors.ROUGE, Colors.JAUNE, Colors.VERT, Colors.BLANC]
			},
			counters: { RED: 0, YELLOW: 0, GREEN: 0, WHITE: 0 }
		}
	},
	computed: {
		filteredVictims: function () {

			if ((!this.criteria.searchQueries || this.criteria.searchQueries.length === 0) && this.criteria.displayedColors.length === 4) {
				return this.victims
			}

			return this.victims.filter(victim => {
				return StringUtils.matchAll(victim.searchText, this.criteria.searchQueries)
					&& this.criteria.displayedColors.includes(victim.checkupColor)
			})
		},
		isSau: function () {
			return EntityTypes.SAU === UserService.getCurrentUser().entityType
		},
		isCra: function () {
			return EntityTypes.CRRA === UserService.getCurrentUser().entityType
		},
		isTmp: function () {
			return EntityTypes.EPHEMERE === UserService.getCurrentUser().entityType
		},
		isSystem: function () {
			return UserService.getCurrentUser().hasProfile('SYSTEM')
		},
		isDoctor: function () {
			return UserService.getCurrentUser().doctor
		},
		isDae: function () {
			return this.$route.name === 'Daes'
		},
		percent: function () {
			return this.currentTime / this.delai * 100
		},
		showCriteriaOnlyWithoutDestCRA: function () {
			return !this.isDae && this.isCra
		}
	},
	methods: {
  		rowClassName({row, rowIndex}) {
			return row.checkupColor.toLowerCase() + '-background lightColor hover victim-row'
		},
		getFormatedHour(date) {
			return moment(date).format('LT')
		},
		getFormatedDate(date) {
			return moment(date).format('DD/MM')
		},
		sortByName(a, b) {
			let c = StringUtils.compareIgnoreCase(a.lastname, b.lastname)
			if (c === 0) {
				c = StringUtils.compareIgnoreCase(a.firstname, b.firstname)
			}
			return c
		},
		sortByDate(a, b) {
			return moment(a.checkupReceiptDate).diff(b.checkupReceiptDate, 'minutes')
		},
		sortByAge(a, b) {

			const ma = moment().subtract(a.age, a.ageType === 'J' ? 'days' : (a.ageType === 'M' ? 'months' : 'years'))
			const mb = moment().subtract(b.age, b.ageType === 'J' ? 'days' : (b.ageType === 'M' ? 'months' : 'years'))

			return mb.diff(ma, 'days')
		},
		sortByAddress(a, b) {
			let c = StringUtils.compareIgnoreCase(a.zipCode, b.zipCode)
			if (c === 0) {
				c = StringUtils.compareIgnoreCase(a.town, b.town)
			}
			if (c === 0) {
				c = StringUtils.compareIgnoreCase(a.address1, b.address1)
			}
			if (c === 0) {
				c = StringUtils.compareIgnoreCase(a.address2, b.address2)
			}
			if (c === 0) {
				c = StringUtils.compareIgnoreCase(a.address3, b.address3)
			}
			return c
		},
		sortByDisaster(a, b) {
			return StringUtils.compareIgnoreCase(a.disasterName, b.disasterName)
		},
		sortByDestinationSP(a, b) {
			return StringUtils.compareIgnoreCase(a.destinationSP, b.destinationSP)
		},
		sortByObservationCRA(a, b) {
			return StringUtils.compareIgnoreCase(a.observationCRA, b.observationCRA)
		},
		sortByDestinationCRA(a, b) {
			return StringUtils.compareIgnoreCase(a.destinationCRA, b.destinationCRA)
		},
		sortByPrescriptionCount(a, b) {
			return a.prescriptionCount - b.prescriptionCount
		},
		sortByFrench(a, b) {
			if (a.french === null) {
				return b === null ? 0 : 1; // Mettre les valeurs nulles à la fin
			} 
			if (b.french === null) {
				return -1; // Mettre les valeurs nulles à la fin
			} 
			return a.french - b.french;
		},
		setSearchQueries() {
			if (this.timeout) clearTimeout(this.timeout); 
			this.timeout = setTimeout(() => {

				if (this.criteria.searchQuery) {
					this.criteria.searchQueries = this.criteria.searchQuery.split(' ')
				} else {
					this.criteria.searchQueries = []
				}

				// Mémorise les critères de recherche en session
				this.saveCriteria()

			}, 350);
		},
		toggleColor(color) {

			const index = this.criteria.displayedColors.indexOf(color)
			if (index !== -1) {
				this.criteria.displayedColors.splice(index, 1)
			} else {
				this.criteria.displayedColors.push(color)
			}

			// Mémorise les critères de recherche en session
			this.saveCriteria()
		},
		setRange() {
			// Positionne un flag pour dire que les dates par défaut ont été modifiée
			this.criteria.defaultDateRange = false

			// Si la date du jour, n'est plus dans l'intervalle
			// on suspend le refresh
			if (moment().isAfter(moment(this.criteria.dateRange[1], 'YYYY-MM-DD'), 'day')) {
				this.suspendRefresh = true
			} else {
				this.suspendRefresh = false
			}

			// Mémorise les critères de recherche en session
			this.saveCriteria()

			this.getData(true)
		},
		setCriteria() {
			// Mémorise les critères de recherche en session
			this.saveCriteria()

			this.getData(true)
		},
		getData(forced) {
			
			// Remet le refresh au debut
			if (forced) {
				this.loading = true
				this.currentTime = 0
			}

			this.processing = true;
			
			// On teste pour savoir si l'on utilise la coche DAE ou la coche bilan
			const showClosed = this.isDae ? this.criteria.showClosedDae : this.criteria.showClosed

			// Appel de l'api
			VictimService.getVictims(this.criteria.dateRange, showClosed, this.isDae, this.criteria.onlyWithoutDestCRA).then((result) => {

				// Pour chaque ligne
				result.victims.forEach(victim => {
					// Construit une string utilisée pour la recherche textuelle
					victim.searchText = Object.values(victim).join(" ")

					// Fixe l'id de destination
					if (victim.entityId) {
						victim.destId = victim.entityId
					}
					else if (victim.tmpUserId) {
						victim.destId = 't' + victim.tmpUserId
					}
					else if (!victim.transportCRA) {
						victim.destId = 'NO_TRANSP'
					}
					
					// Recherche si la victime était déjà présente dans le tableau
					const v = this.victims.find(v => v.id === victim.id)

					// Récupère les valeurs en cours d'édition de cette victime
					if (v) {
						victim.editObs = v.editObs
						victim.observationCRA_edit = v.observationCRA_edit
						victim.editDest = v.editDest
					}
					// Sinon fixe le flag a false pour l'édition de l'observation et la destination CRRA
					else {
						victim.editObs = false
						victim.observationCRA_edit = ''
						victim.editDest = false
					}
				});

				// Mise à jour des dates sélectionnées
				this.criteria.dateRange = [moment(result.start).format('YYYY-MM-DD'), moment(result.end).format('YYYY-MM-DD')]

				this.victims = result.victims
				this.loading = false

				this.$nextTick(function () {
					this.$refs.victimsTable.doLayout()
				})

				this.processing = false;
			})

			// Appel de l'api pour récupérer les compteurs
			if (!this.isDae) {
				VictimService.countVictims().then((counters) => {
					this.counters = counters
				})
			}
		},
		clickRow(row, column) {

			// On a cliqué dans la colonne observation cra
			// et on est un CRA
			if (column.columnKey === 'obs' && (this.isCra || this.isSystem)) {
				if (!row.editObs) {
					row.editObs = true
					row.observationCRA_edit = row.observationCRA
					this.$nextTick(function () {
						this.$refs['obsInput' + row.id].focus()
					})
				}
			}
			// On a cliqué dans la colonne destination cra
			// et on est un CRA
			else if (column.columnKey === 'dest-cra' && (this.isCra || this.isSystem)) {
				if (!row.editDest) {
					row.editDest = true
					this.$nextTick(function () {
						this.$refs['destSelect' + row.id].focus()
					})
				}
			}
			// On a cliqué dans la colonne prescription cra
			else if (column.columnKey === 'pres-cra') {
				this.$router.push({ path: '/checkups/' + row.id + '/' + row.checkupOrder, query: { showPrescriptions: true } })
			}
			// On a cliqué sur une autre colonne ou on est SAU
			else {
				// Si on est dans le menu DAE
				if(this.isDae) {
					this.$router.push('/daes/' + row.id + '/' + row.checkupOrder);
				} else{
					this.$router.push('/checkups/' + row.id + '/' + row.checkupOrder);
				}
				
			}
		},
		saveObs(row) {

			this.loading = true

			// Appel de l'api
			VictimService.updateObs(row.id, row.observationCRA_edit).then((victim) => {

				row.observationCRA = victim.observationCRA
				row.searchText = Object.values(victim).join(" ")
				row.editObs = false
				this.loading = false
			})
		},
		saveDest(row) {

			this.loading = true

			// Appel de l'api
			VictimService.updateDest(row.id, row.destId).then((victim) => {

				// Fixe l'id de destination
				if (victim.entityId) {
					victim.destId = victim.entityId
				}
				else if (victim.tmpUserId) {
					victim.destId = 't' + victim.tmpUserId
				}

				row.destinationCRA = victim.destinationCRA
				row.transportCRA = victim.transportCRA
				row.checkupState = victim.checkupState
				row.searchText = Object.values(victim).join(" ")
				row.editDest = false
				this.loading = false
			})
		},
		saveCriteria() {

			// Mémorise les critères de recherche en session
			sessionStorage.setItem("criteria_victims", JSON.stringify(this.criteria))

			// Ici les critères ont été modifiés
			// donc on affiche le bouton pour les effacer
			this.showClearButton = true

		},
		clearCriteria() {

			this.criteria = {
				dateRange: undefined,
				defaultDateRange: true,
				searchQuery: '',
				searchQueries: [],
				showClosed: false,
				showClosedDae: false,
				displayedColors: [Colors.ROUGE, Colors.JAUNE, Colors.VERT, Colors.BLANC]
			}

			// Retire les critères de recherche en session
			sessionStorage.removeItem("criteria_victims")

			// Masque le bouton pour effacer les critères
			this.showClearButton = false

			// Remet le refresh au debut
			this.suspendRefresh = false
			this.loading = true
			this.currentTime = 0

			// Récupère la liste de victimes
			this.getData()
		},
		refresh() {

			if (this.suspendRefresh || this.processing) {
				this.currentTime = 0

			} else if (this.currentTime + 250 > this.delai) {
				this.currentTime = 0

				// Actualise la liste de victimes
				this.getData()

			} else {
				this.currentTime += 250
			}

		},
		tooltipTextDevenirSP: function(value){
			if(value.regulationDecision != null){
				return 'Décision prise par le '+value.regulationDecision.name
			}
				return '';	
		}
    },
	mounted: function() {

		// Charge les critères de recherche mémorisé en session
		const sessionCriteria = sessionStorage.getItem("criteria_victims")
		if (sessionCriteria) {
			this.criteria = JSON.parse(sessionCriteria)

			// Affiche le bouton pour effacer les critères
			this.showClearButton = true
		}

		// Si la date du jour, n'est plus dans l'intervalle
		// on suspend le refresh
		if (moment().isAfter(moment(this.criteria.dateRange[1], 'YYYY-MM-DD'), 'day')) {
			this.suspendRefresh = true
		} else {
			this.suspendRefresh = false
		}

		if (this.isCra || this.isSystem) {

			// Charge et tri la liste des entités de type SAU
			EntityService.getEntities(true).then((entities) => {
				this.entitiesSAU = entities
				this.entitiesSAU.sort((a, b) => StringUtils.compareIgnoreCase(a.name, b.name));
			})

			// Charge et tri la liste des utilisateurs éphémères
			UserService.getTemporariesUsers(true).then((tmpUsers) => {
				this.tmpUsers = tmpUsers
				this.tmpUsers.sort((a, b) => StringUtils.compareIgnoreCase(a.lastname+a.firstname, b.lastname+b.firstname));

				// Pour chaque utilisateur éphémère
				// Rajoute le caractère 't' devant l'id
				// pour éviter la collision avec les id des entités
				this.tmpUsers.forEach(tmpUser => {
					tmpUser.id = 't' + tmpUser.id
				})
			})
		}

		// Récupère la liste de victimes
		this.getData()
		
		// Lance le refresh
		this.intervalId = window.setInterval(this.refresh, 250)
	},
	beforeDestroy: function() {

		// Arrete le refresh
		if (this.intervalId) {
			clearInterval(this.intervalId)
		}
	}
}
</script>

<style>

.filter-card {
	margin-bottom: 10px;
}

.color-button-badge ~ .color-button-badge {
	margin-left: 22px;
}

.victims-card {
	height: calc(100vh - 250px);
}

.el-table .cell {
	padding-left: 5px;
	padding-right: 5px;
}

.victim-header .cell, .victim-row .cell {
	word-break: normal;
}

.victim-row {
	cursor: pointer;
}

.victim-row td {
	padding: 4px 0;
}

.hover:hover > td {
	background-color: initial !important;
}

.col1 > div, .col3 > label {
	width: 100% !important;
}

.col4 > button {
	height: 32px;
}

.hidden {
    visibility: hidden;
}

.obs-cell i, .dest-cell i, .pres-cell i {
	color: #666;
}

.obs-input textarea {
	padding-bottom: 23px;
}

.victims-table:not(.sau) td.obs-cell:hover, .victims-table:not(.sau) td.obs-cell:hover i,
.victims-table:not(.sau) td.dest-cell:hover, .victims-table:not(.sau) td.dest-cell:hover i,
.pres-cell:hover, .pres-cell:hover i {
	color: #409EFF;
}

.victims-table:not(.sau) .obs-cell, .victims-table:not(.sau) .dest-cell {
	cursor: text;
}

.cell-edit {
	display: flex;
}

.cell-edit-btn i {
	display: block;
	margin-top: 4px;
	margin-bottom: 6px;
	margin-left: 5px;
	cursor: pointer;
}

.entity-option {
	height: 46px;
	line-height: 20px;
}

.subtext {
	color: #8492a6;
	font-size: 10.5px;
}

@media only screen and (max-width:1199px) {
	.col1, .col2 {
		margin-bottom: 10px;
	}

	.victims-card {
		height: calc(100vh - 290px);
	}

	.victims-table {
		height: calc(100vh - 330px) !important;
	}
}

@media only screen and (max-width:991px) {
	.col4 {
		text-align: center
	}
}

@media only screen and (max-width:767px) {
	.col1, .col2, .col3 {
		margin-bottom: 10px;
	}

	.col4 {
		text-align: center;
	}

	.victims-card {
		height: calc(100vh - 330px);
	}

	.victims-card.small {
		height: calc(100vh - 370px);
	}

	.victims-table {
		height: calc(100vh - 365px) !important;
	}

	.victims-table.small {
		height: calc(100vh - 400px) !important;
	}

	.color-button-badge ~ .color-button-badge {
		margin-left: 15px;
	}

	.color-button-badge:nth-child(4) {
		margin-right: 54px;
	}
}

</style>
